import { useSelector } from 'react-redux';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useAnalytics } from 'use-analytics';
import FlightItinerary from '../FlightItinerary';
import {
  FlightSearchTypes, SearchModeLabel, SearchModes, SearchStatus,
} from '../../../../constants';
import Plane from '../../../../assets/svgs/plane.svg';
import withSpinner from '../../../../HOCs/withSpinner';
import isFlightSegmentsValid from '../../../../helpers/validationHelpers/isFlightSegmentsValid';
import TravelBlurbs from '../../../TravelBlurbs';
import CustomBreadcrumb from '../../../TravelOptions/BreadCrumbs';
import flightSearchInput from '../../../../helpers/selectors/flightSearchInput';
import { checkDoEnableSelectFlightsBySegment } from '../../../../store/slices/user';
import isValidFlightSegments from '../../../../helpers/validationHelpers/isValidFlightSegments';

const FlightList = ({
  onViewMoreClick, isInsideModal, tripId, onModalClose, doCheckoutOnSelect,
}) => {
  const flightSearchState = useSelector((state) => state.flight.flightSearches[tripId]);
  const trip = useSelector((store) => store.trip.selectedTrips[tripId]);
  const responses = useSelector((state) => state.flight.responses);
  const [response, setResponse] = useState(null);
  const { track } = useAnalytics();
  const doEnableSelectFlightsBySegment = useSelector(checkDoEnableSelectFlightsBySegment);
  const flightSearchType = flightSearchState && flightSearchState.searchObj
  && flightSearchState.searchObj.flightSearchType;
  const { selectedFlightSegments, breadCrumbsIndex } = useSelector(
    flightSearchInput(tripId, !tripId),
  );
  // TODO: useCallback?
  useEffect(() => {
    if (flightSearchState && responses) {
      if (trip && trip.flightItinerary) {
        setResponse(() => ({
          ...responses[flightSearchState.queryString],
          flightItineraries: responses[flightSearchState.queryString]
          && responses[flightSearchState.queryString].flightItineraries
          && responses[flightSearchState.queryString].flightItineraries
            .filter((item) => item.flightKey !== trip.flightItinerary.flightKey),
        }));
      } else {
        setResponse(responses[flightSearchState.queryString]);
      }
      track('flightList.setFlightSearchResponse', {
        queryString: flightSearchState.queryString,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flightSearchState, trip, responses]);

  const renderComponent = () => (
    <>
      {(flightSearchState
      && flightSearchState.searchStatus === SearchStatus.DONE
      && response
      && response.flightItineraries
      && Object.values(response.flightItineraries).length)
        ? (
          <>
            <div>
              <TravelBlurbs type={SearchModeLabel[SearchModes.FLIGHT].toLowerCase()} />
              {response.flightItineraries.map((itinerary) => (
                <FlightItinerary
                  key={`${itinerary.flightKey}-${itinerary.id}`}
                  itinerary={itinerary}
                  tripId={tripId}
                  onModalClose={onModalClose}
                  isModalOpen={isInsideModal}
                  doCheckoutOnSelect={doCheckoutOnSelect}
                />
              ))}
            </div>
            {onViewMoreClick && !(flightSearchType === FlightSearchTypes.DIRECT_SELL) && (
              <button onClick={onViewMoreClick} type="button" className="border border-theme block rounded-pill text-center rounded-2xl text-x text-theme py-3 mx-auto mb-5 w-64 font-bold">
                {!isInsideModal
                  && (
                    <span>
                      View more
                      <FaChevronDown className="inline-block ml-3" />
                    </span>
                  )}
                {isInsideModal
                  && (
                    <span>
                      View less
                      <FaChevronUp className="inline-block ml-3" />
                    </span>
                  )}
              </button>
            )}
          </>
        ) : (
          <div className="flex items-center flex-col h-40 justify-center gap-3 text-center">
            <Plane />
            {(!(flightSearchType === FlightSearchTypes.DIRECT_SELL)
            && !isFlightSegmentsValid(flightSearchState.searchObj.flightSegments,
              flightSearchState.searchObj.flightSearchType)
              ? 'Please specify a flight origin and/or destination in filters above to search flights.'
              : `Flights not found for ${response && response.doHaveResultsWithoutFilter ? 'selected filters' : 'your search parameters'}. ${breadCrumbsIndex > 0 && Object.keys(selectedFlightSegments).length > 0 ? 'Try changing one of your earlier flights to see available options.' : ''}`)}
            {((flightSearchType === FlightSearchTypes.DIRECT_SELL)
            && !isValidFlightSegments(flightSearchState.searchObj.flightSegments)
              ? 'Please check your inputs - some required fields are missing or invalid.'
              : 'No flights found for your direct sell request.')}
          </div>
        )}
    </>
  );
  return (
    <>
      {doEnableSelectFlightsBySegment
       && (flightSearchState?.searchStatus === SearchStatus.SEARCHING || response)
       && (flightSearchType === FlightSearchTypes.MULTI_CITY
       || flightSearchType === FlightSearchTypes.ROUND_TRIP)
       && (
       <CustomBreadcrumb
         tripId={tripId}
       />
       )}
      {withSpinner(renderComponent, (!flightSearchState
    || flightSearchState.searchStatus === SearchStatus.INITIAL
    || flightSearchState.searchStatus === SearchStatus.SEARCHING))}
    </>
  );
};

FlightList.propTypes = {
  onViewMoreClick: PropTypes.func,
  isInsideModal: PropTypes.bool,
  tripId: PropTypes.string.isRequired,
  onModalClose: PropTypes.func,
  doCheckoutOnSelect: PropTypes.bool,
};

FlightList.defaultProps = {
  isInsideModal: false,
  onViewMoreClick: undefined,
  onModalClose: undefined,
  doCheckoutOnSelect: false,
};

export default FlightList;
